import { render, staticRenderFns } from "./save-sign-notes.vue?vue&type=template&id=58967aea&"
import script from "./save-sign-notes.vue?vue&type=script&lang=js&"
export * from "./save-sign-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports